import {Int, intersection, TypeOf} from 'io-ts';
import {NonNegative} from './NonNegative';

export const NonNegativeInt = intersection([Int, NonNegative]);

export type NonNegativeInt = TypeOf<typeof NonNegativeInt>;
